export default function Footer() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-xl text-background-50 whitespace-nowrap">
                芭乐视频
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed mb-4">
              芭乐视频是聚合香蕉视频、西瓜视频、蜜桃视频、樱桃视频等水果视频平台资源的高清在线观看平台，提供免费电影电视剧综艺动漫，每日更新不缓冲。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" onClick={(e) => { e.preventDefault(); scrollTo('#hero'); }} className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 text-background-100 transition-colors cursor-pointer">
                <i className="ri-home-line text-sm"></i>
              </a>
              <a href="#contact" onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }} className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 text-background-100 transition-colors cursor-pointer">
                <i className="ri-mail-line text-sm"></i>
              </a>
              <a href="#faq" onClick={(e) => { e.preventDefault(); scrollTo('#faq'); }} className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 text-background-100 transition-colors cursor-pointer">
                <i className="ri-question-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 text-sm mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '专题合集', href: '#index' },
                { label: '更新动态', href: '#updates' },
                { label: '热播榜单', href: '#ranking' },
                { label: '精选视频', href: '#media' },
                { label: '常见问答', href: '#faq' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => { e.preventDefault(); scrollTo(item.href); }}
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 text-sm mb-4">热门分类</h4>
            <div className="flex flex-col gap-2.5">
              {['电影', '电视剧', '综艺', '动漫', '纪录片'].map((cat) => (
                <a
                  key={cat}
                  href="#media"
                  onClick={(e) => { e.preventDefault(); scrollTo('#media'); }}
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {cat}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 text-sm mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-400">
              更多合作伙伴即将上线，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2026 芭乐视频 - 水果视频平台高清在线观看。本站内容仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4">
            <a href="#faq" onClick={(e) => { e.preventDefault(); scrollTo('#faq'); }} className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
              服务条款
            </a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }} className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
              联系我们
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}